import React, {useState, useEffect} from 'react';
import {Link, useHistory} from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';
import ErrorMessage from "./error/ErrorMessage";
import {servicesSelector} from '../../../../store/reducers/selServReducer';
import {primaryContractSelector} from '../../../../store/reducers/primConReducer';
import {secondContractSelector} from '../../../../store/reducers/secConReducer';
import {scrollSelector, classAdded} from '../../../../store/reducers/scrollReducer';
import {transformStateToAgiloft} from "../../../../store/transformers/agiloftTransformer";
import {selectCompanyInfo} from "../../../../store/reducers/companyInfoReducer";
import {promoCodeSelector} from '../../../../store/reducers/promoCodeReducer';
import api from "../../../../constants/api";
import LoadingSpinner from "../../../common/LoadingSpinner";
import { skipSecConSelector } from '../../../../store/reducers/skipSecContReducer';
import {recaptchaSiteKey} from "../../../../constants";
import { registrationSettingsSelector } from '../../../../store/reducers/registrationSettingsReducer'; 

function Summary({ companyInfo }) {
    const dispatch = useDispatch();
    const serviceArr = useSelector(servicesSelector);
    const skipSecCon = useSelector(skipSecConSelector);
    const companyInformation = useSelector(selectCompanyInfo);
    const primaryContract = useSelector(primaryContractSelector);
    const secondaryContract = useSelector(secondContractSelector);
    const registrationData = useSelector(registrationSettingsSelector);
    const promoCode = useSelector(promoCodeSelector);
    const scroll = useSelector(scrollSelector);
    const [scrollClass, setScrollClass] = useState(scroll);
    const [promoCodeIs, setPromoCodeIs] = useState(false);
    let history = useHistory();
    const [selected, setSelected] = useState(false);
    const [showError, setShowError] = useState(false);
    const [showErrorMissing, setShowErrorMissing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState([]);
    const [previousPath, setPreviousPath] = useState("/form/secondary")

    useEffect(() => {
        setTimeout(function(){ setScrollClass("progression_container large"); }, 10);

        if(promoCode.isHuri === true) {
            setPromoCodeIs(true);
        }
        if(promoCode.code !== "") {
            setPreviousPath("/form/nomination");
        }
    }, []); // eslint-disable-line

    function toggleError() {
        setShowError(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if(selected === false) {
            setShowError(true);
            return;
        } else if(promoCode.isHuri === true) {
            if((promoCode.code === "") || (serviceArr.length === 0) || (primaryContract.length === 0)) {
                setShowErrorMissing(true);
                return;
            } else {
                setIsLoading(true);
                setErrors([]);

                const token = await window.grecaptcha.execute(recaptchaSiteKey, {action: 'submit'})
                const data = transformStateToAgiloft(companyInformation, primaryContract, secondaryContract, serviceArr, promoCode, token);
                const response = await api.submitAgiloftData(data);

                setIsLoading(false);
                const errors = response.errors?.map(error => error.message) || [];
                setErrors(errors);

                if (errors.length === 0) {
                    history.push('/success');
                }
            }
        } else {   
            if((companyInformation.name === "") || (serviceArr.length === 0) || (primaryContract.length === 0) || (secondaryContract.length === 0)) {
                setShowErrorMissing(true);
                return;
            } else {     
                setIsLoading(true);
                setErrors([]);

                const token = await window.grecaptcha.execute(recaptchaSiteKey, {action: 'submit'})
                const data = transformStateToAgiloft(companyInformation, primaryContract, secondaryContract, serviceArr, promoCode, token);
                const response = await api.submitAgiloftData(data);

                setIsLoading(false);
                const errors = response.errors?.map(error => error.message) || [];
                setErrors(errors);

                if (errors.length === 0) {
                    history.push('/success');
                }
            }
        }
    }

    function setClass() {
        dispatch(classAdded("progression_container large startTop"))
    }

    return (
        <>
            <Link to={previousPath} onClick={setClass} className="previous large">Previous <span>
                <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10.0815 6.5201L8.27352 8.3281L7.52152 9.0961C6.92952 9.6881 6.30552 10.3121 5.64952 11.0001H7.77752C8.92952 9.8001 11.3615 7.1441 12.7215 5.7841C11.3775 4.4401 8.94552 1.8001 7.77752 0.600098H5.64952C6.30552 1.2881 6.92952 1.9121 7.52152 2.5041L8.27352 3.2721L8.99352 4.0081C9.45752 4.4561 9.84152 4.8721 10.0815 5.0801H0.561523V6.5201H10.0815Z"
                        fill="white"></path>
                </svg>
            </span></Link>
            <div className="form-choosenCompany"><span className="your-company-text">Your company:</span> {companyInfo?.name !== "" && <span>{companyInfo.name}</span>}</div> 

            <div className={scrollClass}>
                <h2>Summary</h2>
                <p className="summary-p">{registrationData.summary_description}</p>
                <form className="summary-form" onSubmit={handleSubmit}>
                    <div className="list-divider"></div>
                    <div className="flex_container_column">
                        <div className="first">
                            <label><b>Service:</b></label>
                            <Link to="/form/?summary=true" onClick={setClass}>
                                <div className="edit">See service</div>
                            </Link>
                        </div>
                        <div className="services">
                            <div className="service">{serviceArr}</div>
                        </div>
                    </div>
                    <div className="list-divider"></div>
                    <div className="flex_container contract">
                        <div>
                            <div>
                                <label><b>Primary contract administrator:</b></label>
                            </div>
                            <div>
                                <Link to="/form/primary/?summary=true" onClick={setClass}>
                                    <div className="edit right">Edit</div>
                                </Link>
                            </div>
                        </div>
                        <div className="flex_info">
                            <div>
                                <p>{primaryContract.firstName}</p>
                                <p>{primaryContract.lastName}</p>
                            </div>
                            <div>
                                <p>{primaryContract.mobileNum}</p>
                                <p>{primaryContract.email}</p>
                            </div>
                            <div></div>
                        </div>
                    </div>
                    <div className="list-divider"></div>
                    <div className="flex_container contract">
                        <div>
                            <div>
                                <label><b>Secondary contract administrator:</b></label>
                            </div>
                            <div>
                                <Link to="/form/secondary/?summary=true" onClick={setClass}>
                                    <div className="edit right">Edit</div>
                                </Link>
                            </div>
                        </div>
                       
                            {skipSecCon.isSkipped === true 
                                ? <div className="flex_info"> 
                                    <div>
                                        <p className="dimmed">This step has been skipped</p>
                                    </div>
                                    <div>
                                        <p className="dimmed">Click on edit if you want to add information</p>
                                    </div>
                                    <div></div>
                                </div>
                                : <div className="flex_info">
                                    <div>
                                        <p>{secondaryContract.firstName}</p>
                                        <p>{secondaryContract.lastName}</p>
                                    </div>
                                    <div>
                                        <p>{secondaryContract.mobileNum}</p>
                                        <p>{secondaryContract.email}</p>
                                    </div>
                                    <div></div>
                                </div>
                            }
                    </div>

                    {promoCodeIs === true &&
                        <>
                            <div className="list-divider"></div>
                            <div className="flex_container contract">
                                <div>
                                    <div>
                                        <label><b>Nomination code:</b></label>
                                    </div>
                                    <div>
                                        <Link to="/form/nomination/?summary=true" onClick={setClass}>
                                            <div className="edit right">Edit</div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="flex_info">
                                    <div>
                                        <p>{promoCode.code}</p>
                                    </div>
                                    <div></div>
                                    <div></div>
                                </div>
                            </div>
                        </>
                    }

                    <div onClick={toggleError}>
                        <div className="accept-contact" onClick={() => {setSelected(!selected)}}>
                            <div className="toggleContainer">
                                <div className="toggleGroup">
                                    <div className={`toggle-container ${!selected ? "" : "disabledBackground"}`}>
                                        <div className={`dialog-button ${selected ? "" : "disabled"}`}></div>
                                    </div>
                                </div>

                            </div>
                            <div className="accept-label">
                                    <p>{registrationData.summary_accept}</p>
                                </div>

                            {showError && <ErrorMessage>Click slider to accept</ErrorMessage>}
                        </div>
                        <div>
                            <p className="terms-link"><a target="_blank" href="/en/terms/">{registrationData.summary_terms}</a></p>
                        </div>

                        {errors.length > 0 && (
                            <div className="errors">
                                <div>
                                    {errors.map((error, index) => <p key={index}>{error}</p>)}
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="button_container">
                    {showErrorMissing === true && <p className="missing-fields_error">Some fields are missing, please fill them in to send application</p>}
                        <button className="nextSubmit submit" type="submit" onClick={() => window.plausible('Registration Submit')} disabled={isLoading}>
                            {isLoading ? <LoadingSpinner small={true} light={true}/> : (
                                <>
                                    <span>Send application</span>
                                    <svg width="13" height="11" viewBox="0 0 13 11" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M10.0815 6.5201L8.27352 8.3281L7.52152 9.0961C6.92952 9.6881 6.30552 10.3121 5.64952 11.0001H7.77752C8.92952 9.8001 11.3615 7.1441 12.7215 5.7841C11.3775 4.4401 8.94552 1.8001 7.77752 0.600098H5.64952C6.30552 1.2881 6.92952 1.9121 7.52152 2.5041L8.27352 3.2721L8.99352 4.0081C9.45752 4.4561 9.84152 4.8721 10.0815 5.0801H0.561523V6.5201H10.0815Z"
                                            fill="white"/>
                                    </svg>
                                </>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
}

export default Summary;
